import { render, staticRenderFns } from "./OpenBankingFailed.vue?vue&type=template&id=93be5e2c&"
import script from "./OpenBankingFailed.vue?vue&type=script&lang=ts&"
export * from "./OpenBankingFailed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports